import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useState, useEffect, useRef } from "react";
import React from "react";

import AlertDialog from "../lib/AlertDialog";
import AppDelegate from "../AppDelegate";
import Util from "../common/Util";

const ContactComp = (props) => {
  const { pitch } = props;

  const { executeRecaptcha } = useGoogleReCaptcha();

  const [isLoading, setIsLoading] = useState(false);
  const [uiFirstName, setUiFirstName] = useState("");
  const [uiLastName, setUiLastName] = useState("");
  const [uiEmail, setUiEmail] = useState("");
  const [uiMessage, setUiMessage] = useState("");

  const firstNameRef = useRef('');
  const lastNameRef = useRef('');
  const emailRef = useRef('');
  const messageRef = useRef('');

  const [uiFirstNameError, setUiFirstNameError] = useState(false);
  const [uiLastNameError, setUiLastNameError] = useState(false);
  const [uiEmailError, setUiEmailError] = useState(false);
  const [uiMessageError, setUiMessageError] = useState(false);

  const recaptchaRef = useRef(null);



  useEffect(() => {
    firstNameRef.current = uiFirstName;
    lastNameRef.current = uiLastName;
    emailRef.current = uiEmail;
    messageRef.current = uiMessage;

  }, [uiFirstName, uiLastName, uiEmail, uiMessage]);


  useEffect(() => {
  }, []);

  const submitQuery = async (token) => {
    setIsLoading(true);

    const req = {
      firstName: firstNameRef.current,
      lastName: lastNameRef.current,
      email: emailRef.current,
      message: messageRef.current,
      recaptcha: token,
    };

    const result = await AppDelegate.reqSubmitQuery(req);

    if (result.code === 200) {
      const param = {
        title: "Submitted Successfully",
        msg: "We have received your message and we will get back to you shortly.",
        confirmTitle: "Back",
        onConfirm: () => {
          setUiFirstName("");
          setUiLastName("");
          setUiEmail("");
          setUiMessage("");

          setIsLoading(false);

          return true;
        }
      }
      AlertDialog.showAlert(param);
    } else {
      const param = {
        title: "Submitted Failed",
        msg: "We got some problems. Please retry later.",
        confirmTitle: "Back",
        onConfirm: () => {
          setIsLoading(false);

          return true;
        }
      }
      AlertDialog.showAlert(param);
    };

    // Reset the widget for future submissions
    // window.grecaptcha.reset(widgetIdRef.current);
  };

  const validateInput = () => {
    var isValid = true;

    setUiFirstNameError(false);
    setUiLastNameError(false);
    setUiEmailError(false);
    setUiMessageError(false);

    if (uiFirstName === "") {
      setUiFirstNameError("Please enter your first name");
      isValid = false;
    }
    if (uiLastName === "") {
      setUiLastNameError("Please enter your last name");
      isValid = false;
    }
    if (uiEmail === "") {
      setUiEmailError("Please enter your email");
      isValid = false;
    } else if (!Util.validateEmail(uiEmail)) {
      setUiEmailError("Please enter a valid email");
      isValid = false;
    }
    if (uiMessage === "") {
      setUiMessageError("Please enter your message");
      isValid = false;
    }

    return isValid;
  }

  const onClickSendMessage = async (e) => {
    e.preventDefault();
    if (validateInput()) {

      if (!executeRecaptcha) {
        console.log('Execute recaptcha not yet available');
        // Potentially show a loading indicator or disable the button
        return;
      }

      // Execute reCAPTCHA to get the token. 'submit_form' is an action name you define.
      // It helps Google associate the request with your site's traffic patterns.
      const token = await executeRecaptcha('submit_query');
      if (!token) {
          alert('reCAPTCHA token could not be generated. Please try again.');
          return;
      }


      submitQuery(token);
    }
  }

  return (

    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-container">
          <div className="contact-info">
            <h2>Get In Touch</h2>
            <p>
              Need mobile forensics expertise? Contact our team for a confidential consultation. We're here to help you navigate complex digital investigations with precision and professionalism.
            </p>
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                </div>
                <div className="contact-item-text">
                  <h4>Email Us</h4>
                  <p><a href="mailto:info@true-extract.co.uk">info@true-extract.co.uk</a></p>
                </div>
              </div>
              <div className="contact-item">
                  <div className="contact-icon">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                          <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                  </div>
                  <div className="contact-item-text">
                      <h4>Office Location</h4>
                      <p>DATA IN LTD, 124 City Road, London, EC1V 2NX</p>
                  </div>
              </div>
              {/* <div className="contact-item">
                <div className="contact-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </div>
                <div className="contact-item-text">
                  <h4>Call Us</h4>
                  <p>+44 (0) 1234 567890</p>
                </div>
              </div> */}
              <div className="contact-item">
                <div className="contact-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                </div>
                <div className="contact-item-text">
                  <h4>Hours</h4>
                  <p>Mon-Fri: 9AM - 6PM</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <div id="successMessage" className="success-message">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ display: "inline-block", verticalAlign: "middle", marginAight: "8px" }}>
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              Thank you! Your message has been received. We'll get back to you shortly.
            </div>
            <form id="contactForm">
              <div className="form-group">
                <label htmlFor="first_name">First Name *</label>
                <input
                  type="text"
                  id="firstName"
                  value={uiFirstName}
                  disabled={isLoading}
                  onChange={(e) => {
                    setUiFirstNameError(false);
                    setUiFirstName(e.target.value);
                  }}
                />
                {uiFirstNameError && <div className="error-message">{uiFirstNameError}</div>}
              </div>
              <div className="form-group">
                <label htmlFor="last_name">Last Name *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={uiLastName}
                  disabled={isLoading}
                  onChange={(e) => {
                    setUiLastNameError(false);
                    setUiLastName(e.target.value);
                  }}
                />
                {uiLastNameError && <div className="error-message">{uiLastNameError}</div>}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={uiEmail}
                  disabled={isLoading}
                  onChange={(e) => {
                    setUiEmailError(false);
                    setUiEmail(e.target.value);
                  }}
                />
                {uiEmailError && <div className="error-message">{uiEmailError}</div>}
              </div>
              {/* <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input type="tel" id="phone" name="phone" />
              </div> */}
              {/* <div className="form-group">
                <label htmlFor="service">Service Needed</label>
                <select id="service" name="service">
                  <option value="">Select a service...</option>
                  <option value="data-export">Data Export & Backup</option>
                  <option value="format-conversion">Format Conversion</option>
                  <option value="data-analysis">Data Analysis</option>
                  <option value="consultation">General Consultation</option>
                </select>
              </div> */}
              <div className="form-group">
                <label htmlFor="message">Your Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={uiMessage}
                  disabled={isLoading}
                  onChange={(e) => {
                    setUiMessageError(false);
                    setUiMessage(e.target.value);
                  }}
                />
                {uiMessageError && <div className="error-message">{uiMessageError}</div>}
              </div>
              <div ref={recaptchaRef}></div>
              <button
                className="submit-btn"
                disabled={isLoading}
                onClick={onClickSendMessage}
              >
                  Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

  );
};

export default ContactComp;




